// import { getDefaultData } from "./defaultData";

import { getDefaultData } from "./defaultData";

export const convertToTableData = (data) => {
  return data?.results?.map((item) => {
    const semesterData = item.json?.table || {};

    const apaData = getDefaultData().map((defaultItem, index) => {
      const key = defaultItem.apa.id;
      return {
        ...defaultItem,
        key: semesterData[key]?.id || index,
        count: semesterData[key]?.count || 0,
        modal: semesterData[key]?.modal || [],
      };
    });

    // Adding the APA point for the semester
    const apaPointItem = apaData.find((item) => item.apa.id === 'apa_point');
    if (apaPointItem) {
      apaPointItem.count = item.apa_point || 0;
    }

    return {
      id: item.id,
      semester: item.semester,
      semester_name: `Semester ${item.semester}`,
      apa_point: item.apa_point,
      status: item.status,
      comment: item.comment,
      data: apaData,
    };
  }) || [];
};



export const convertToRequestData = (planning, selectedYear, formId, semester) => {
  const semesterPlan = planning.find((plan) => plan.semester === semester);
  if (!semesterPlan) {
    return null;
  }

  const tableData = semesterPlan.courses.reduce((acc, item) => {
    acc[item.apa.id] = {
      key: item.id,
      count: item.count,
      modal: item.modal || [],
    };
    return acc;
  }, {});

  return {
    apa_form: formId,
    year: selectedYear,
    semester: semester,
    // apa_point: semesterPlan.data.find(item => item.apa.id === 'apa_point')?.count || 0,
    json: {
      table: tableData,
    },
  };
};




// export const convertPlanningToRequestData = (planning, year, formId) => {
//   return planning.map((plan) => ({
//     apa_form: formId,
//     year: year,
//     semester: plan.semester,
//     apa_point: plan.data.find(item => item.apa.id === 'apa_point')?.count || 0,
//     json: {
//       table: plan.data.reduce((acc, item) => {
//         acc[item.apa.id] = {
//           count: item.count,
//           modal: item.modal || [],
//         };
//         return acc;
//       }, {}),
//     },
//   }));
// };
export const convertPlanningToRequestData = (planningData, year, apa_form) => {
  return planningData.map((plan) => {
    const tableData = {
      taking_per_audit: {
        count: plan.taking_per_audit?.count || 0,
        modal: plan.taking_per_audit?.modal || [],
      },
      new_course_teaching: {
        count: plan.new_course_teaching?.count || 0,
        modal: plan.new_course_teaching?.modal || [],
      },
      course_module_design: {
        count: plan.course_module_design?.count || 0,
        modal: plan.course_module_design?.modal || [],
      },
      course_file_completion: {
        count: plan.course_file_completion?.count || 0,
        modal: plan.course_file_completion?.modal || [],
      },
    };

    return {
      apa_form: apa_form,
      year: year,
      semester: plan.semester,
      apa_point: plan.apa_point || 0,
      json: {
        table: tableData,
      },
    };
  });
};
